import React, { useMemo, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { NovaStore } from "./store/NovaStore";
import ChatInterface from "./components/ChatInterface";

interface NovaProps {
  instanceId?: string;
  localStore?: NovaStore;
}

const Nova: React.FC<NovaProps> = observer(({ instanceId, localStore }) => {
  if (!localStore) {
    return (
      <div className="relative flex flex-col items-center justify-center w-full h-full overflow-hidden">
        <div className="text-white">Error: No local store found for Nova</div>
      </div>
    );
  }

  const store = localStore as NovaStore;

  useEffect(() => {
    console.log("Nova: Store object:", store);
    console.log(
      "Nova: Store methods:",
      Object.getOwnPropertyNames(Object.getPrototypeOf(store))
    );
    console.log(
      "Nova: initializeWorkflow exists:",
      typeof store.initializeWorkflow
    );

    if (typeof store.initializeWorkflow === "function") {
      store.initializeWorkflow();
    } else {
      console.error("Nova: initializeWorkflow is not a function!");
    }

    // Debug: Log current workflow state
    console.log("Nova: Current workflow state:", store.currentWorkflow);
    console.log("Nova: Workflow context:", store.workflowContext);
  }, [store]);

  const handleSendMessage = (message: string) => {
    console.log("Nova: User sent message:", message);
    store.addMessage("user", message);
    store.processUserInput(message);
  };

  const handleFileUpload = (file: File) => {
    console.log("Nova: File uploaded:", file.name, file.size);
    store.handleFileUpload(file);
  };

  const handleEncryptedFileUpload = (file: File) => {
    console.log("Nova: Encrypted file uploaded:", file.name, file.size);
    store.handleEncryptedFileUpload(file);
  };

  if (!store || !store.messages) {
    return (
      <div className="relative flex flex-col items-center justify-center w-full h-full overflow-hidden">
        <div className="text-white">Loading Nova...</div>
      </div>
    );
  }

  return (
    <div className="relative w-full h-full overflow-hidden">
      <div className="pointer-events-none fixed inset-0 z-[0] overflow-hidden">
        <img
          className="absolute left-[2%] top-[20%] w-[32%]"
          src="/images/shadows/1.svg"
          alt=""
        />
        <img
          className="absolute bottom-[5%] right-[-6%] w-[48%]"
          src="/images/shadows/2.svg"
          alt=""
        />
        <img
          className="absolute bottom-[0%] left-[-12%] w-[47%]"
          src="/images/shadows/3.svg"
          alt=""
        />
      </div>
      <div className="pointer-events-none fixed w-full h-full inset-0 z-[0] overflow-hidden">
        <img
          src="/images/shadows/lines.png"
          alt=""
          className="absolute -bottom-[247px] -left-[153px]"
        />
      </div>

      <div className="relative z-[10] w-full h-full overflow-hidden">
        <ChatInterface
          messages={store.messages}
          onSendMessage={handleSendMessage}
          onFileUpload={handleFileUpload}
          onEncryptedFileUpload={handleEncryptedFileUpload}
          isTyping={store.isTyping}
          currentWorkflow={store.currentWorkflow}
          isGenerating={store.isGenerating}
          uploadedFile={store.uploadedFile}
          encryptedFile={store.encryptedFile}
        />
      </div>
    </div>
  );
});

export default Nova;
